import { Component, OnInit, Input, Output } from '@angular/core'
import { Subject } from 'rxjs'
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@modal/confirm-dialog/confirm-dialog.component'
import { HelperService } from '@service/helper.service';
import $ from 'jquery'
import { MobileService } from '@service/mobile.service'
import { StateService } from '@service/state.service';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { EntityTypeConfig } from '@model/entity-type-config';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-searchbar[entityTypeIdentifier]',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
})
export class SearchbarComponent implements OnInit {

  @Input() preflightValues: string[]

  public searchText_desktop: string = "suchen"
  public searchText_mobile: string = "suchen"

  @Input()
  public newButtonText: string = "erstellen"

  @Output() onSearch: Subject<any> = new Subject()
  @Output() onPreflightSearch: Subject<string> = new Subject()

  public query: string = ""

  @Input()
  entityTypeIdentifier: EntityTypeIdentifier
  entityTypeConfig: EntityTypeConfig

  constructor(
    private dialog: MatDialog,
    public MobileService: MobileService,
    public HelperService: HelperService,
    public StateService: StateService,
    public EntityTypeConfigService: EntityTypeConfigService,
    public ActivatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.entityTypeConfig = this.EntityTypeConfigService.getConfigByName(this.entityTypeIdentifier)

    this.ActivatedRoute.queryParams.subscribe(queryParams => {
      if (typeof queryParams.search_string == "undefined" || queryParams.search_string == null)
        this.query = ""
      else
        this.query = decodeURIComponent(this.StateService.queryParams.search_string)
    })
  }

  public preflightSearch() {
    // PREFLIGHT SEARCH DEACTIVATED
    // https://gitea.aceart.de/aceArtGmbH/zimmerer-treffpunkt-app/issues/62
    // this.onPreflightSearch.next(this.query)
  }

  public blur(event) {
    event.target.blur()
  }

  public searchBlur($event) {

    // blur of input fires before click on mat option
    // this is a hack to take the mat option value if clicked on
    if ($event.explicitOriginalTarget && $event.explicitOriginalTarget.textContent &&
      $event.explicitOriginalTarget.nodeName == "MAT-OPTION") {
      console.log("explicitOriginalTarget mat-option clicked")
      this.query = $event.explicitOriginalTarget.textContent
    }
    else if ($event.relatedTarget && $event.relatedTarget.textContent &&
      $event.relatedTarget.nodeName == "MAT-OPTION") {
      console.log("relatedTarget mat-option clicked")
      this.query = $event.relatedTarget.textContent
    }

    if (this.query.length < 3 && this.query.length > 0)
      this.atLeastThreeCharsDialog()
    else
      this.onSearch.next({ filter: 'search_string', value: this.query })

    // hack to defocus input
    $('body').click()
  }

  private atLeastThreeCharsDialog() {
    const confirmConfig = {
      text: 'Für eine Suche müssen mindestens drei Zeichen eingegeben werden.',
      buttons: [
        {
          text: 'OK',
          value: 'abort',
        },
      ],
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: confirmConfig,
      disableClose: true,
      panelClass: ConfirmDialogComponent.cssClass
    })

    $('#query').val('')
  }

  public localGotoCreate() {
    this.StateService.goto(this.entityTypeConfig.createstate)
  }
}